import React from "react";
import Label from './LabelUtilsComponet'

const PrintDocument = ({ config }) => {
  return (
    <div className={config.classContainer}>
      <Label {...config} />
      <div className='div-input-form'>
        <input type="button" className={config.classInput} onClick={() => window.print()} value={config.btnLabel} />
      </div>
    </div>
  )
}

export default PrintDocument;
